<!--copyright css start-->
<div class="cyclops copyright">
    <div class="container">
        <div class="row">
            <div class="col-sm-6">
                <!-- <div class="link-horizontal">
                    <ul>
                        <li>
                            <a href="#" class="copyright-text op-text">Privacy Policy</a>
                        </li>
                        <li>
                            <a href="#" class="copyright-text op-text">Terms & Conditions</a>
                        </li>
                    </ul>
                </div> -->
            </div>
            <div class="col-sm-6">
                <div>
                    <h6 class="copyright-text text-white text-right op-text">Copyright ©2025 Cyclops </h6>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- copyright css end-->
